import { PILL } from "../constants/tokens";
import { OFFICIAL_TAG, isOfficial } from "../utils/geoEvents";
import Icon from "./Icon";

// "מסמך רשמי" — the one mark for a geo_events row that is a Federal Register
// document rather than a news article. Renders nothing for a news row, so a
// caller can drop it in unconditionally. Same label, icon and style in every
// screen (geo list, its modal, the calendar, the home card): a reader learns
// the mark once.
export default function OfficialBadge({ ev, official, size = 12 }) {
  const on = typeof official === "boolean" ? official : isOfficial(ev);
  if (!on) return null;
  return (
    <span style={{ ...PILL.base, ...OFFICIAL_TAG.style }}>
      <Icon name={OFFICIAL_TAG.icon} size={size}/>
      {OFFICIAL_TAG.label}
    </span>
  );
}
